<template>
  <div class="w-full justify-start items-center p-1" @click.stop>
    <div class="w-full flex justify-between" v-if="loaded">
      <v-select label="id" :filterable="false" :options="listUsers" @search="onSearch" v-model="selectUser" :reduce="user_ => user_.id"
                class="w-full bg-white" @input="changeUser" v-bind="$attrs">

        <template #no-options>
          <template v-if="!inviteByEmail">
            <span @click.stop>{{ $t('components.chooseCategory.notFindUser') }}</span>
          </template>
          <template v-else>
            <div v-if="isEmail">
              {{ $t('components.chooseCategory.inviteUserDescription', { email: search_text }) }}
              <vs-button @click="inviteUser" size="small" class="pl-1">
                {{ $t('components.chooseCategory.inviteUserButton') }}
              </vs-button>
            </div>
            <div class="bg-danger-gradient" v-else>
              <span class="text-white">{{ $t('components.chooseCategory.typeToInvite') }}</span>
            </div>
          </template>
        </template>

        <template #option="option">
          <div class="flex items-center">
            <vs-avatar :src="option.dataGeneral.avatar" :text="option.dataGeneral.displayName" size="small"/>
            {{ option.dataGeneral.displayName }}
          </div>
        </template>

        <template #selected-option="option">
          <div class="flex items-center">
            <vs-avatar :src="option.dataGeneral.avatar" :text="option.dataGeneral.displayName" size="small"/>
            {{ option.dataGeneral.displayName }}
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import {showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";
import UserService from "@/services/User.service";
import {User} from "@/models/User.model";

export default {
  /**
   * Component to select a user, it will request to database to find a new user and return a selected user.
   * v-model will contain the user id on database.
   * Use dispatch('Users/lookup') to get the whole object from store
   *
   * Optional:
   *  @roleUser You can set roleUser attribute to find only a specific role
   *  @inviteByEmail if user is not found on database, user can type email, and invite this user.
   *    A blank user will be created with email as displayname
   */
  name: 'ChooseUser',
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      required: true
    },

    roleUser: {
      type: String,
      default: 'all'
    },
    inviteByEmail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: [],
      selectUser: null,

      search_text: "",
      loaded: false,
    };
  },
  watch: {
    value() {
      this.$store.dispatch('Users/lookupUser', this.value).then((response) => {
        this.selectUser = response;
      }, error => {
        showErrorNotify(this, error);
      });
    }
  },
  computed: {
    listUsers() {
      return this.users;
    },
    isEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.search_text);
    }
  },
  methods: {
    onSearch(search, loading) {
      this.search_text = search;
      loading(true);
      this.lodash.debounce((loading, search, vm) => {
        if (!search || search.length == 0) {
          loading(false);
          return;
        }

        // user is keeping typing
        if (vm.search_text != search) {
          loading(false);
          return;
        }

        UserService.queryUser(this.roleUser, search).then((response) => {
          vm.users = [];
          response.forEach(u => {
            vm.users.push(User.FromObj(u));
          });

        }).catch((error) => {
          showErrorNotify(vm, error);
        }).finally(() => {
          loading(false);
        });
      }, 500)(loading, search, this);
    },
    changeUser(newVal) {
      let sendValue = newVal;
      if (!newVal) {
        sendValue = 0;
      }

      this.$emit('input', sendValue);
    },
    inviteUser() {
      const payload = {
        email: this.search_text
      };

      UserService.inviteDoctor(payload).then((response) => {
        this.$store.dispatch('Users/setUser', response).then(() => {
          this.changeUser(response.id);
          showSuccessNotify(this, 'User invited successfully');
        });
      }, (error) => {
        showErrorNotify(this, error);
      });
    }
  },
  created() {
    this.loaded = false;
  },
  mounted() {
    if (this.value && this.value > 0) {
      this.$store.dispatch('Users/lookupUser', this.value).then((response) => {
        this.selectUser = response;
      }, error => {
        showErrorNotify(this, error);
      });
    }
    this.loaded = true;
  }
}
</script>

<style scoped>

</style>
